import { gql } from '@apollo/client';

/**
 * Operación GraphQL: laborHoursReport.
 *
 * Consume el resolver de `rois-back` slice 1 (PR #14): agrega ActionLaborEntry
 * por operario en un rango de fechas, con filtros opcionales por team
 * (snapshot), userIds y states (multiselect de estados de actuación; reemplaza
 * el antiguo `onlyValidated`). RBAC: SuperAdmin/Coex.
 *
 * El operationName `FetchLaborHoursReport` es contractual — NO renombrar
 * (mocks E2E dependen de él).
 */
export const FETCH_LABOR_HOURS_REPORT = gql`
  query FetchLaborHoursReport($filter: LaborHoursReportFilter!) {
    laborHoursReport(filter: $filter) {
      rows {
        kind
        subjectId
        subjectName
        teamIDsSnapshot
        totalMinutes
        operatorsNumber
        byHourType {
          hourType
          minutes
        }
        orders {
          orderId
          actionId
          routeId
          sourceType
          segmentsCount
          roid
          date
          startTime
          endTime
          state
          concessionIDs
          minutes
          predefined
          description
          durationMinutes
          operatorsNumber
          isSimultaneous
          grossMinutes
          deductedMinutes
        }
      }
    }
  }
`;
